module.exports = __webpack_public_path__ + "static/media/test.d6630550.jpg";